// import React, { useEffect, useState } from "react";
// import GasData from "./GasData.json";
// import useApi from "../../../CustomHooks/useApi";
// import { useSelector } from "react-redux";

// const GasBillpay = () => {
//   const [billers, setBillers] = useState([]);
//   const [boardSearch, setBoardSearch] = useState("");
//   const [showBoardDropdown, setShowBoardDropdown] = useState(false);
//   const [billData, setBillData] = useState(null);
//   const [mpin, setMpin] = useState("");
//   const [manualAmount, setManualAmount] = useState("");

//   const [showModal, setShowModal] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const [modalMessage, setModalMessage] = useState("");

//   const [formData, setFormData] = useState({
//     operator: "",
//     consumerNumber: "",
//     mobileNo: "",
//   });

//   const merchantId = useSelector(
//     (state) => state.auth.employeeDetails?.username
//   );

//   const account_no = useSelector(
//     (state) => state.auth.employeeDetails?.merchant_account_no
//   );

//   const { callApi: callFetch, loading } =
//     useApi("/recharge/gas-info", "POST");

//   const { callApi: callPay, loading: payLoading } =
//     useApi("/recharge/transaction/gas", "POST");

//   useEffect(() => {
//     const gasBillers = GasData
//       .filter((item) => item.ebill_type === "gas")
//       .map((b) => ({
//         name: b.ebill_board,
//         code: b.ebill_code,
//       }));

//     setBillers(gasBillers);
//   }, []);

//   useEffect(() => {
//     document.body.style.overflow = showModal ? "hidden" : "auto";
//   }, [showModal]);

//   const resetAll = () => {
//     setBillData(null);
//     setMpin("");
//     setManualAmount("");
//     setFormData({
//       operator: "",
//       consumerNumber: "",
//       mobileNo: "",
//     });
//     setBoardSearch("");
//     setShowBoardDropdown(false);
//   };

//   const filteredBoards = billers.filter((b) =>
//     b.name.toLowerCase().includes(boardSearch.toLowerCase())
//   );

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const isValidMpin = (mpin) => /^\d{4,6}$/.test(mpin);

//   // 🔥 FETCH BILL
//   const handleFetchBill = async () => {
//     try {
//       const payload = {
//         consumerNumber: formData.consumerNumber,
//         mobileNo: formData.mobileNo,
//         operator: formData.operator,
//       };

//       const res = await callFetch(payload);

//       if (res?.status === 1) {
//         setBillData(res);
//       } else {
//         setModalType("error");
//         setModalMessage(res?.message || "Gas Bill Fetch Failed");
//         setShowModal(true);
//       }
//     } catch {
//       setModalType("error");
//       setModalMessage("Server error");
//       setShowModal(true);
//     }
//   };

//   // 🔥 PAY BILL
//   const handlePayNow = async () => {
//     try {
//       if (!isValidMpin(mpin)) {
//         setModalType("error");
//         setModalMessage("MPIN must be 4–6 digits");
//         setShowModal(true);
//         return;
//       }

//       const isAdani = formData.operator === "AG";

//       const amount = isAdani
//         ? Number(manualAmount || 0)
//         : Number(billData?.rdata?.[0]?.Billamount || 0);

//       const payload = {
//         optr: formData.operator,
//         type: "GAS",
//         consumerNo: formData.consumerNumber,
//         bill_amount: amount,
//         mobile: formData.mobileNo,
//         mid: merchantId,
//         txn_amount: amount,
//         net_amount: amount,
//         merchant_account_no: account_no,
//         mpin: mpin,
//         add_params: {
//           param1: "",
//           param2: "",
//         },
//       };

//       const res = await callPay(payload);

//       if (res?.status === "SUCCESS") {
//         setModalType("success");
//         setModalMessage(res?.customerSummary || "Payment Successful");
//       } else if (res?.status === "PENDING") {
//         setModalType("pending");
//         setModalMessage(res?.customerSummary || "Transaction Pending");
//       } else {
//         setModalType("error");
//         setModalMessage(res?.message || "Payment Failed");
//       }

//       setShowModal(true);
//     } catch {
//       setModalType("error");
//       setModalMessage("Payment Failed ❌");
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className="w-full px-4 py-6">
//       <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-lg p-6">

//         <h2 className="text-2xl font-bold text-[#12345A]">
//           Gas Bill Payment
//         </h2>
//         <p className="text-gray-500 text-sm mb-6">
//           Secure & fast payment
//         </p>

//         {/* SEARCH */}
//         <div className="relative mb-5">
//           <input
//             type="text"
//             placeholder="Search Gas Provider"
//             value={boardSearch}
//             onChange={(e) => {
//               setBoardSearch(e.target.value);
//               setShowBoardDropdown(true);
//             }}
//             className="w-full px-4 py-3 border rounded-xl"
//           />

//           {showBoardDropdown && (
//             <div className="absolute w-full bg-white rounded-xl shadow mt-1 max-h-40 overflow-y-auto">
//               {filteredBoards.map((b) => (
//                 <div
//                   key={b.code}
//                   onClick={() => {
//                     setFormData((prev) => ({
//                       ...prev,
//                       operator: b.code,
//                     }));
//                     setBoardSearch(b.name);
//                     setShowBoardDropdown(false);
//                   }}
//                   className="p-3 hover:bg-gray-50 cursor-pointer"
//                 >
//                   {b.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* FORM */}
//         {formData.operator && !billData && (
//           <div className="grid md:grid-cols-2 gap-4">
//             <input
//               name="consumerNumber"
//               placeholder="Consumer Number"
//               value={formData.consumerNumber}
//               onChange={handleChange}
//               className="px-4 py-3 border rounded-xl"
//             />

//             <input
//               name="mobileNo"
//               placeholder="Mobile Number"
//               value={formData.mobileNo}
//               onChange={handleChange}
//               className="px-4 py-3 border rounded-xl"
//             />

//             <button
//               onClick={handleFetchBill}
//               className="md:col-span-2 py-3 bg-[#12345A] text-white rounded-xl"
//             >
//               {loading ? "Fetching..." : "Fetch Bill"}
//             </button>
//           </div>
//         )}

//         {/* BILL */}
//         {billData && (
//           <div className="mt-6 space-y-4">

//             <div className="bg-gradient-to-br from-[#EEF2FF] to-white p-5 rounded-2xl border shadow-sm">
//               <p className="font-semibold text-[#12345A] text-lg">
//                 {billData?.rdata?.[0]?.CustomerName}
//               </p>

//               <div className="mt-3 space-y-1 text-sm text-gray-600">
//                 <p>📅 Bill Date: {billData?.rdata?.[0]?.Billdate}</p>
//                 <p>⏳ Due Date: {billData?.rdata?.[0]?.Duedate}</p>
//               </div>

//               <p className="text-2xl font-bold text-green-600 mt-3">
//                 ₹ {billData?.rdata?.[0]?.Billamount}
//               </p>
//             </div>

//             {/* ONLY ADANI */}
//             {formData.operator === "AG" && (
//               <input
//                 type="number"
//                 placeholder="Enter Amount"
//                 value={manualAmount}
//                 onChange={(e) => setManualAmount(e.target.value)}
//                 className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-[#12345A]"
//               />
//             )}

//             <input
//               type="password"
//               maxLength={6}
//               placeholder="Enter MPIN"
//               value={mpin}
//               onChange={(e) =>
//                 setMpin(e.target.value.replace(/\D/g, ""))
//               }
//               className="w-full text-center text-2xl tracking-[10px] py-3 border rounded-xl"
//             />

//             <button
//               onClick={handlePayNow}
//               className="w-full py-3 bg-[#12345A] text-white rounded-xl"
//             >
//               {payLoading ? "Processing..." : "Pay Now"}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* MODAL */}
//       {showModal && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[9999]">
//           <div className="w-[90%] max-w-sm bg-white rounded-3xl p-6 text-center">

//             <h2 className="text-xl font-bold mb-2">
//               {modalType === "success" && "Success"}
//               {modalType === "error" && "Error"}
//               {modalType === "pending" && "Pending"}
//             </h2>

//             <p className="mb-6">{modalMessage}</p>

//             <button
//               onClick={() => {
//                 setShowModal(false);
//                 resetAll();
//               }}
//               className="w-full py-3 bg-[#12345A] text-white rounded-xl"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GasBillpay;

import React, { useEffect, useState, useRef } from "react";
import GasData from "./GasData.json";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const GasBillpay = () => {
  const [billers, setBillers] = useState([]);
  const [boardSearch, setBoardSearch] = useState("");
  const [showBoardDropdown, setShowBoardDropdown] = useState(false);
  const [billData, setBillData] = useState(null);
  const [mpin, setMpin] = useState("");
  const [manualAmount, setManualAmount] = useState("");
  const dropdownRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalMessage, setModalMessage] = useState("");

  const [formData, setFormData] = useState({
    operator: "",
    consumerNumber: "",
    mobileNo: "",
  });

  const merchantId = useSelector(
    (state) => state.auth.employeeDetails?.username
  );

  const account_no = useSelector(
    (state) => state.auth.employeeDetails?.merchant_account_no
  );

  const { callApi: callFetch, loading } = useApi("/recharge/gas-info", "POST");
  const { callApi: callPay, loading: payLoading } = useApi("/recharge/transaction/gas", "POST");

  useEffect(() => {
    const gasBillers = GasData
      .filter((item) => item.ebill_type === "gas")
      .map((b) => ({
        name: b.ebill_board,
        code: b.ebill_code,
      }));

    setBillers(gasBillers);
  }, []);

  // Handle click outside to close dropdown safely
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowBoardDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  const resetAll = () => {
    setBillData(null);
    setMpin("");
    setManualAmount("");
    setFormData({
      operator: "",
      consumerNumber: "",
      mobileNo: "",
    });
    setBoardSearch("");
    setShowBoardDropdown(false);
  };

  const filteredBoards = billers.filter((b) =>
    b.name.toLowerCase().includes(boardSearch.toLowerCase())
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidMpin = (mpin) => /^\d{4,6}$/.test(mpin);

  // 🔥 FETCH BILL
  const handleFetchBill = async () => {
    if (!formData.operator || !formData.consumerNumber || !formData.mobileNo) {
      setModalType("error");
      setModalMessage("Please fill in all required fields.");
      setShowModal(true);
      return;
    }

    try {
      const payload = {
        consumerNumber: formData.consumerNumber,
        mobileNo: formData.mobileNo,
        operator: formData.operator,
      };

      const res = await callFetch(payload);

      if (res?.status === 1) {
        setBillData(res);
      } else {
        setModalType("error");
        setModalMessage(res?.message || "Gas Bill Fetch Failed");
        setShowModal(true);
      }
    } catch {
      setModalType("error");
      setModalMessage("Server error");
      setShowModal(true);
    }
  };

  // 🔥 PAY BILL
  const handlePayNow = async () => {
    try {
      if (!isValidMpin(mpin)) {
        setModalType("error");
        setModalMessage("MPIN must be 4–6 digits");
        setShowModal(true);
        return;
      }

      const isAdani = formData.operator === "AG";

      const amount = isAdani
        ? Number(manualAmount || 0)
        : Number(billData?.rdata?.[0]?.Billamount || 0);

      if (amount <= 0) {
        setModalType("error");
        setModalMessage("Invalid payment amount.");
        setShowModal(true);
        return;
      }

      const payload = {
        optr: formData.operator,
        type: "GAS",
        consumerNo: formData.consumerNumber,
        bill_amount: amount,
        mobile: formData.mobileNo,
        mid: merchantId,
        txn_amount: amount,
        net_amount: amount,
        merchant_account_no: account_no,
        mpin: mpin,
        add_params: {
          param1: "",
          param2: "",
        },
      };

      const res = await callPay(payload);

      if (res?.status === "SUCCESS") {
        setModalType("success");
        setModalMessage(res?.customerSummary || "Payment Successful");
      } else if (res?.status === "PENDING") {
        setModalType("pending");
        setModalMessage(res?.customerSummary || "Transaction Pending");
      } else {
        setModalType("error");
        setModalMessage(res?.message || "Payment Failed");
      }

      setShowModal(true);
    } catch {
      setModalType("error");
      setModalMessage("Payment Failed ❌");
      setShowModal(true);
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex flex-col items-center justify-start pt-12 md:pt-0 px-6 font-sans">
      {/* <div className="w-full max-w-2xl pt-12 pb-24"> */}
      <div className="w-full  pt-12 pb-24">
        
        {/* HEADER */}
        <h2 className="text-3xl md:text-4xl font-bold text-[#12345A] text-center mb-10 tracking-tight">
          Gas Bill Payment
        </h2>

        {!billData ? (
          <div className="w-full animate-[fadeIn_.3s_ease-out]">
            
            {/* ==========================================
                BOARD SEARCH DROPDOWN
               ========================================== */}
            <div className="mb-6 relative" ref={dropdownRef}>
              <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                Select Gas Provider
              </label>
              
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search provider name..."
                  value={boardSearch}
                  onChange={(e) => {
                    setBoardSearch(e.target.value);
                    setShowBoardDropdown(true);
                  }}
                  onFocus={() => setShowBoardDropdown(true)}
                  className={`w-full rounded-none bg-transparent border-b-2 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none transition-all ${
                    showBoardDropdown ? "border-[#12345A]" : "border-gray-200 focus:border-[#12345A]"
                  }`}
                />
                {/* Search Arrow/Icon */}
                <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>

              {/* Dropdown Menu List */}
              {showBoardDropdown && (
                <div className="absolute z-20 w-full mt-2 bg-white border border-gray-100 rounded-2xl shadow-[0_10px_40px_rgb(0,0,0,0.08)] overflow-hidden max-h-72 overflow-y-auto animate-[fadeIn_.2s_ease-out]">
                  {filteredBoards.length > 0 ? (
                    filteredBoards.map((b) => (
                      <div
                        key={b.code}
                        onClick={() => {
                          setFormData((prev) => ({
                            ...prev,
                            operator: b.code,
                          }));
                          setBoardSearch(b.name);
                          setShowBoardDropdown(false);
                        }}
                        className={`px-5 py-4 text-xl cursor-pointer transition-colors ${
                          formData.operator === b.code 
                            ? "bg-indigo-50 border-l-4 border-[#12345A]" 
                            : "hover:bg-gray-50 border-l-4 border-transparent"
                        }`}
                      >
                        <span className="text-gray-900 font-medium">{b.name}</span>
                      </div>
                    ))
                  ) : (
                    <div className="px-5 py-6 text-lg text-gray-400 font-medium text-center">
                      No gas provider found.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ==========================================
                DYNAMIC FIELDS
               ========================================== */}
            {formData.operator && (
              <div className="animate-[fadeIn_.3s_ease]">
                <div className="mb-6">
                  <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                    Consumer Number
                  </label>
                  <input
                    type="text"
                    name="consumerNumber"
                    value={formData.consumerNumber}
                    onChange={handleChange}
                    placeholder="Enter consumer number"
                    className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none focus:border-[#12345A] transition-all"
                  />
                </div>

                <div className="mb-10">
                  <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                    Mobile Number
                  </label>
                  <input
                    type="tel"
                    name="mobileNo"
                    maxLength={10}
                    value={formData.mobileNo}
                    onChange={(e) => setFormData(prev => ({...prev, mobileNo: e.target.value.replace(/\D/g, '')}))}
                    placeholder="Enter 10-digit mobile number"
                    className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none focus:border-[#12345A] transition-all"
                  />
                </div>

                {/* Fetch Bill Button */}
                <button
                  onClick={handleFetchBill}
                  disabled={loading || !formData.consumerNumber || formData.mobileNo.length < 10}
                  className="w-full bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl focus:ring-4 focus:ring-[#12345A]/20 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex justify-center items-center"
                >
                  {loading ? (
                    <span className="flex items-center gap-3">
                      <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Fetching Details...
                    </span>
                  ) : (
                    "Fetch Bill Details"
                  )}
                </button>
              </div>
            )}
          </div>
        ) : (
          /* ==========================================
             BILL SUMMARY & PAYMENT
            ========================================== */
          <div className="w-full animate-[fadeIn_.3s_ease-out]">
            
            {/* Bill Details Card */}
            <div className="bg-indigo-50/50 border border-indigo-100 rounded-3xl p-6 md:p-8 mb-8 relative overflow-hidden">
              {/* Abstract decorative shape */}
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-indigo-100 rounded-full opacity-50 blur-2xl"></div>
              
              <div className="relative z-10">
                <p className="text-gray-500 text-sm font-semibold uppercase tracking-widest mb-1">Customer Name</p>
                <h3 className="text-2xl md:text-3xl font-bold text-[#12345A] mb-6">
                  {billData?.rdata?.[0]?.CustomerName || "N/A"}
                </h3>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-1">Bill Date</p>
                    <p className="text-gray-900 font-medium text-lg">{billData?.rdata?.[0]?.Billdate || "—"}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-1">Due Date</p>
                    <p className="text-red-600 font-bold text-lg">{billData?.rdata?.[0]?.Duedate || "—"}</p>
                  </div>
                </div>

                <div className="pt-6 border-t border-indigo-100 flex justify-between items-end">
                  <p className="text-gray-500 text-sm font-semibold uppercase tracking-widest">Total Amount</p>
                  <p className="text-4xl font-extrabold text-[#12345A]">
                    ₹{billData?.rdata?.[0]?.Billamount || "0.00"}
                  </p>
                </div>
              </div>
            </div>

            {/* ONLY ADANI - Manual Amount Override */}
            {formData.operator === "AG" && (
              <div className="mb-6">
                <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                  Enter Payment Amount (₹)
                </label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={manualAmount}
                  onChange={(e) => setManualAmount(e.target.value)}
                  className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none focus:border-[#12345A] transition-all"
                />
              </div>
            )}

            {/* MPIN INPUT */}
            <div className="mb-10">
              <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                Confirm MPIN
              </label>
              <input
                type="password"
                maxLength={6}
                placeholder="••••••"
                value={mpin}
                onChange={(e) => setMpin(e.target.value.replace(/\D/g, ""))}
                className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-[#12345A] px-3 py-4 text-2xl md:text-3xl tracking-[0.5em] text-center focus:outline-none focus:border-[#12345A] transition-all"
              />
            </div>

            <div className="flex gap-4">
              <button
                onClick={resetAll}
                className="w-1/3 bg-transparent border-2 border-gray-200 text-gray-500 font-bold text-lg py-4 rounded-xl hover:bg-gray-50 transition-all focus:outline-none"
              >
                Cancel
              </button>

              <button
                onClick={handlePayNow}
                disabled={payLoading || mpin.length < 4}
                className="w-2/3 bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl focus:ring-4 focus:ring-[#12345A]/20 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex justify-center items-center"
              >
                {payLoading ? (
                  <span className="flex items-center gap-3">
                    <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </span>
                ) : (
                  `Pay ₹${formData.operator === "AG" ? (manualAmount || "0") : (billData?.rdata?.[0]?.Billamount || "0")}`
                )}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ==========================================
          POPUP MODAL
         ========================================== */}
      {showModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-white/90 backdrop-blur-sm px-4 transition-opacity">
          <div className="bg-white rounded-3xl shadow-[0_10px_40px_rgb(0,0,0,0.1)] border border-gray-100 w-full max-w-sm p-8 text-center animate-[fadeIn_.2s_ease-out]">
            
            <div className={`mx-auto flex items-center justify-center h-20 w-20 rounded-full mb-6 ${
                modalType === 'success' ? 'bg-green-50 text-green-600' : 
                modalType === 'pending' ? 'bg-yellow-50 text-yellow-600' : 
                'bg-red-50 text-red-600'
            }`}>
              {modalType === 'success' && (
                <svg className="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path></svg>
              )}
              {modalType === 'error' && (
                <svg className="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12"></path></svg>
              )}
              {modalType === 'pending' && (
                <svg className="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              )}
            </div>

            <h3 className={`text-2xl font-bold mb-3 ${
                modalType === 'success' ? 'text-green-700' : 
                modalType === 'pending' ? 'text-yellow-700' : 
                'text-red-700'
            }`}>
              {modalType === "success" && "Payment Successful"}
              {modalType === "error" && "Payment Failed"}
              {modalType === "pending" && "Transaction Pending"}
            </h3>

            <p className="text-gray-600 font-medium mb-8 leading-relaxed">
              {modalMessage}
            </p>

            <button
              onClick={() => {
                setShowModal(false);
                resetAll();
              }}
              className="w-full bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl transition-all"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GasBillpay;